/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */
import LightingSettings from "./lighting_settings";
import IScene from "../../scene_interface";

export default
class VRLightingSettings extends LightingSettings {
    constructor(aSceneAPI: IScene)
    {
        super(aSceneAPI);

        return;
        // override some settings from parent
        /*this.settings.sunLightEnabled       = false;
        this.settings.headLightEnabled      = true;
        this.settings.headLightIntensity    = 0.15;
        this.settings.ambientLightIntensity = 0.7;
        this.settings.ambientEqualsDiffuse  = false;
        this.settings.sunLightIntensity     = 0.0;
        this.settings.minimalDiffuseLight   = 0.2;*/
    };
}
